import {DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS} from '../../WorkspaceDrawer/Settings/runLinePlots/maxRunDefaults';
import {type RunsLinePlotConfig} from '../types';

export function configSupportsBucketing(
  config: {
    groupAgg?: RunsLinePlotConfig['groupAgg'];
    groupArea?: RunsLinePlotConfig['groupArea'];
    isInReport?: boolean;
    limit?: number;
    allowFullFidelityRanges?: boolean;
  },
  /**
   * The environment-aware max-runs ceiling from getMaxRunsCeiling. When
   * provided, report panels use this instead of the hardcoded default so
   * that ramp flags (e.g. full_fidelity_run_per_chart) are respected.
   */
  maxRunsCeiling?: number
) {
  const warnings = [];

  const reportBucketingLimit =
    maxRunsCeiling ?? DEFAULT_LINE_PLOT_MAX_NUM_BUCKETED_RUNS;
  if (
    config.isInReport &&
    config.limit &&
    config.limit > reportBucketingLimit
  ) {
    warnings.push(`max runs limit over ${reportBucketingLimit}`);
  }

  /**
   * We don't support samples in full fidelity mode, and only support stderr/stddev if the ramp flag is enabled
   */
  if (
    config.groupArea === 'samples' ||
    (!config.allowFullFidelityRanges &&
      ['stderr', 'stddev'].includes(config.groupArea ?? ''))
  ) {
    warnings.push('unsupported group aggregation');
  }

  return warnings;
}

/** Retains the warning list while the inputs used to build its messages are unchanged. */
export function useBucketingWarnings(
  {
    groupArea,
    limit,
    isInReport,
    allowFullFidelityRanges,
  }: Parameters<typeof configSupportsBucketing>[0],
  maxRunsCeiling?: number
): string[] {
  // This pure hook has no hook calls, so infer mode needs an explicit opt-in.
  'use memo';

  return configSupportsBucketing(
    {groupArea, limit, isInReport, allowFullFidelityRanges},
    maxRunsCeiling
  );
}
